module.exports = __webpack_public_path__ + "img/expand.eb2b02a5.svg";